import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "upgrade",
  "use": "upgrade-usage",
  "viewBox": "0 0 20 13.11",
  "content": "<symbol viewBox=\"0 0 20 13.11\" id=\"upgrade\"><title>upgrade</title><path d=\"M19.68,3.45,17,4.25a.25.25,0,0,0-.1.42l.7.67-6.15,6.15L8.5,8.55l-.06,0,0,0a.5.5,0,0,0-.7,0L.15,15.71a.49.49,0,1,0,.68.71L8.06,9.5l3,3a.49.49,0,0,0,.56.1.49.49,0,0,0,.26-.14L18.31,6l.62.59a.25.25,0,0,0,.41-.12L20,3.75A.25.25,0,0,0,19.68,3.45Z\" transform=\"translate(0 -3.44)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/upgrade.svg
// module id = hgk7
// module chunks = 264